import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-2xl px-6 py-20 text-center">
      <h1 className="font-serif text-6xl text-gold-light">404</h1>
      <p className="mt-4 text-cream/70">Page not found.</p>
      <Link to="/" className="btn-ghost mt-8">
        {t('common.back')}
      </Link>
    </div>
  );
}
